module.exports = __webpack_public_path__ + "static/media/App_Store.7a04a385.png";